import { InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  appUrl: string;
  appId: string;
  tenantId: string;
  apiUrl: string;
  apiHubUrl: string;
  graphEndpointUrl: string;
  sigaUrlPT: string;
  sigaUrlES: string;
  showFillTable: boolean;
}

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
